module.exports = __webpack_public_path__ + "static/media/contactTen.4e274aa8.jpg";